module.exports = __webpack_public_path__ + "img/shop_environ_2.59aa8668.jpg";